/* Der angedockte Warenkorb am rechten Bildrand.

   Drei Aufgaben:

     1. Platz freihalten. Die Spalte liegt fest am Fensterrand; damit sie
        nichts überdeckt, bekommt der <body> rechts ein Polster in ihrer
        Breite. Über eine Rasterspalte ginge es nicht — die Seite besteht aus
        unabhängigen Sections, jede mit eigener `page-width`.

     2. Auf- und zuklappen, und den Zustand behalten. Wer sie zuklappt, will
        sie auf der nächsten Seite nicht wieder offen haben.

     3. Sich selbst neu holen, wenn sich der Warenkorb ändert. Der Inhalt wird
        über die Section Rendering API geladen, nicht im Browser
        nachgerechnet: Summen, Rabatte und Versandschwellen rechnet Shopify
        serverseitig.

   Unter 1280 px passiert nichts — das erledigt die Medienabfrage im
   Stylesheet, hier wird nur das Polster nicht gesetzt. */
(function () {
  'use strict';

  var SPEICHER = 'vantiq:korb-dock-offen';
  var SCHWELLE = 1280;

  if (!customElements.get('tire-korb-dock')) {
    customElements.define(
      'tire-korb-dock',
      class TireKorbDock extends HTMLElement {
        connectedCallback() {
          this.abschnitt = this.dataset.abschnitt;
          this.breite = this.dataset.breite || '34';

          this.querySelectorAll('[data-rolle="umschalten"]').forEach(
            function (k) {
              k.addEventListener('click', this.umschalten.bind(this));
            }.bind(this)
          );

          this.addEventListener('click', this.klick.bind(this));

          /* Beim ersten Laden gilt der gespeicherte Zustand; ohne Eintrag
             offen — die Spalte soll man sehen, sonst weiss niemand, dass es
             sie gibt. */
          var gespeichert = null;
          try {
            gespeichert = window.localStorage.getItem(SPEICHER);
          } catch (e) {
            /* Privater Modus: dann eben ohne Gedächtnis. */
          }
          this.setzen(gespeichert !== 'zu', true);

          window.addEventListener('resize', this.polster.bind(this));

          /* Eigenes Ereignis aus startseite.js und den Kaufformularen. */
          /* Kommt die Änderung aus einem Kaufformular, geht die Spalte nach dem
             Nachladen auf — auch wenn sie vorher zugeklappt war. Wer etwas in
             den Warenkorb legt, will sehen, dass es drin ist (Thomas
             17.09.2026). Der gespeicherte Zustand bleibt dabei unberührt. */
          document.addEventListener(
            'vantiq:korb-geaendert',
            function (e) {
              this.oeffnenNachLaden = !!(e && e.detail && e.detail.quelle === 'produkt');
              this.neuladen();
            }.bind(this)
          );

          this.zusatzBinden();
        }

        /* Die Zusatzartikel unten in der Spalte: anhaken, Summe im Knopf,
           gemeinsam nachlegen. Dieselbe Rechnung wie im Warenkorb — „pro
           Reifen" multipliziert mit der Reifenzahl, die wirklich im Korb
           liegt. */
        zusatzBinden() {
          /* Erst leeren: Nach einem Austausch des Inhalts zeigen die alten
             Verweise auf Knoten, die nicht mehr im Dokument stehen. */
          this.zusatzKnopf = null;
          this.zusatzText = null;
          this.zusatzKaesten = [];

          var block = this.querySelector('.korb-dock__zusatz');
          if (!block) return;
          this.zusatzKnopf = block.querySelector('[data-rolle="zusatz-hinzufuegen"]');
          this.zusatzText = block.querySelector('[data-rolle="zusatz-text"]');
          this.zusatzKaesten = Array.prototype.slice.call(
            block.querySelectorAll('.tire-addon-checkbox:not([disabled])')
          );
          this.reifen = Math.max(parseInt(block.dataset.reifenzahl, 10) || 0, 1);
          if (!this.zusatzKnopf || !this.zusatzKaesten.length) return;

          this.zusatzKaesten.forEach(
            function (k) {
              k.addEventListener('change', this.zusatzStand.bind(this));
            }.bind(this)
          );
          this.zusatzKnopf.addEventListener('click', this.zusatzHinzufuegen.bind(this));
          this.zusatzStand();
        }

        zusatzAuswahl() {
          return this.zusatzKaesten
            .filter(function (k) { return k.checked; })
            .map(
              function (k) {
                var huelle = k.closest('[data-zusatz]');
                var proReifen = huelle && huelle.hasAttribute('data-pro-reifen');
                return {
                  id: parseInt(k.value, 10),
                  menge: proReifen ? this.reifen : 1,
                  preis: parseInt(k.dataset.addonPrice, 10) || 0
                };
              }.bind(this)
            );
        }

        zusatzStand() {
          var gewaehlt = this.zusatzAuswahl();
          this.zusatzKnopf.hidden = gewaehlt.length === 0;
          if (!gewaehlt.length) return;
          var summe = gewaehlt.reduce(function (s, a) { return s + a.preis * a.menge; }, 0);
          var betrag = (summe / 100).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/, "'");
          this.zusatzText.textContent = window.vantiqText('cart_addons.add_one_price', {
            price: 'CHF ' + betrag,
          });
        }

        zusatzHinzufuegen() {
          var gewaehlt = this.zusatzAuswahl();
          if (!gewaehlt.length) return;
          this.zusatzKnopf.disabled = true;
          this.zusatzText.textContent = window.vantiqText('common.adding');
          fetch(window.Shopify && window.Shopify.routes ? window.Shopify.routes.root + 'cart/add.js' : '/cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({
              items: gewaehlt.map(function (a) { return { id: a.id, quantity: a.menge }; })
            })
          })
            .then(
              function () {
                this.neuladen();
                document.dispatchEvent(new CustomEvent('vantiq:korb-geaendert', { detail: { quelle: 'dock' } }));
              }.bind(this)
            )
            .catch(
              function () {
                this.zusatzKnopf.disabled = false;
                this.zusatzStand();
              }.bind(this)
            );
        }

        /* --- Schnittstelle für Dawns Kaufformular ---------------------------

           `product-form.js` behandelt jeden Empfänger gleich: Es fragt, welche
           Sections mitgerendert werden sollen, hängt sie an die Anfrage und
           übergibt danach die Antwort. Drei Methoden, und das Formular
           schickt niemanden mehr auf die Warenkorbseite. */

        /* Nur wenn die Spalte auch wirklich sichtbar ist. Unter 1280 px hält
           das Stylesheet sie versteckt — dann soll Dawn wie bisher auf die
           Warenkorbseite springen, statt den Klick ins Leere laufen zu
           lassen. */
        uebernimmt() {
          return window.innerWidth >= SCHWELLE;
        }

        getSectionsToRender() {
          return [{ id: this.abschnitt, section: this.abschnitt, selector: 'tire-korb-dock' }];
        }

        setActiveElement(el) {
          this.zuletzt = el;
        }

        renderContents(antwort) {
          var html = antwort && antwort.sections && antwort.sections[this.abschnitt];
          if (!html) {
            this.neuladen();
            return;
          }
          this.einsetzen(html);
          /* Nach dem Hinzufügen offen: Der Zweck des Klicks war, etwas
             hineinzulegen — das soll man sehen. */
          this.setzen(true);
        }

        /* Gemeinsamer Weg für beide Quellen: die eigene Nachlade-Anfrage und
           die Antwort des Kaufformulars. */
        einsetzen(html) {
          var raum = document.createElement('div');
          raum.innerHTML = html;

          /* Bei leerem Korb wird die grosse Produktdetail-CSS nicht geladen.
             Die neu gerenderte Section bringt sie beim ersten Artikel mit.
             Ein Link im losgeloesten Hilfs-DIV wuerde nicht angewendet; daher
             wird er einmalig in den Dokumentkopf uebernommen. */
          var stil = raum.querySelector('[data-vantiq-dock-style]');
          if (stil) {
            var schonGeladen = Array.prototype.some.call(
              document.querySelectorAll('link[rel="stylesheet"]'),
              function (link) { return link.href === stil.href; }
            );
            if (!schonGeladen) document.head.appendChild(stil.cloneNode(true));
          }

          var neu = raum.querySelector('tire-korb-dock');
          if (!neu) {
            this.classList.remove('korb-dock--laedt');
            return;
          }

          this.innerHTML = neu.innerHTML;

          /* Eine leere Antwort heisst: Der Korb ist leer. Dann bleibt das
             Element als stiller Zuhörer stehen — unsichtbar, ohne Breite, ohne
             Polster —, damit das nächste „In den Warenkorb" es wieder
             hervorholt, ohne Seitenwechsel. */
          var leer = !neu.querySelector('.korb-dock__flaeche');
          this.classList.toggle('korb-dock--aus', leer);
          this.classList.remove('korb-dock--laedt');
          if (leer) {
            document.body.style.paddingRight = '';
            return;
          }

          this.querySelectorAll('[data-rolle="umschalten"]').forEach(
            function (k) {
              k.addEventListener('click', this.umschalten.bind(this));
            }.bind(this)
          );
          this.zusatzBinden();
          this.setzen(this.oeffnenNachLaden || this.classList.contains('korb-dock--offen'), true);
          this.oeffnenNachLaden = false;
        }

        umschalten() {
          this.setzen(!this.classList.contains('korb-dock--offen'));
        }

        setzen(offen, still) {
          this.classList.toggle('korb-dock--offen', offen);
          this.querySelectorAll('[aria-expanded]').forEach(function (k) {
            k.setAttribute('aria-expanded', offen ? 'true' : 'false');
          });
          if (!still) {
            try {
              window.localStorage.setItem(SPEICHER, offen ? 'auf' : 'zu');
            } catch (e) {}
          }
          this.polster();
        }

        /* Das Polster steht am <body>, nicht an einem Wrapper: Es gibt keinen
           gemeinsamen Wrapper um alle Sections. */
        polster() {
          /* Ohne Inhalt kein Platzhalten: Die leere Huelle darf die Seite nicht
             um 4.4 rem einruecken. */
          if (this.classList.contains('korb-dock--aus')) {
            document.body.style.paddingRight = '';
            return;
          }
          var breit = window.innerWidth >= SCHWELLE;
          var offen = this.classList.contains('korb-dock--offen');
          document.body.style.paddingRight = breit ? (offen ? this.breite + 'rem' : '4.4rem') : '';
        }

        klick(e) {
          var weg = e.target.closest('[data-rolle="entfernen"]');
          if (!weg) return;
          e.preventDefault();
          this.entfernen(parseInt(weg.dataset.zeile, 10));
        }

        entfernen(zeile) {
          if (!zeile) return;
          this.classList.add('korb-dock--laedt');
          fetch(window.Shopify && window.Shopify.routes ? window.Shopify.routes.root + 'cart/change.js' : '/cart/change.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ line: zeile, quantity: 0 })
          })
            .then(
              function () {
                this.neuladen();
                document.dispatchEvent(new CustomEvent('vantiq:korb-geaendert', { detail: { quelle: 'dock' } }));
              }.bind(this)
            )
            .catch(
              function () {
                this.classList.remove('korb-dock--laedt');
              }.bind(this)
            );
        }

        /* Die Section neu rendern lassen und den Inhalt austauschen. Ersetzt
           wird nur das Innere: Das Element selbst hält Zustand und Zuhörer. */
        neuladen() {
          if (!this.abschnitt) return;
          this.classList.add('korb-dock--laedt');
          fetch(window.location.pathname + '?section_id=' + this.abschnitt, { cache: 'no-store' })
            .then(function (a) {
              return a.text();
            })
            .then(
              function (html) {
                this.einsetzen(html);
              }.bind(this)
            )
            .catch(
              function () {
                this.classList.remove('korb-dock--laedt');
              }.bind(this)
            );
        }
      }
    );
  }
})();
